import {PaymentMain} from "../Components/Payment/PaymentMain"
const CheckOut = () => {
    return (
      <div>
        <PaymentMain/>
      </div>
    );
  };
  export default CheckOut;
  